export const wrapUrlUtm = (url: string): string => {
  if (!url) {
    return url
  }

  if (url.includes('?')) {
    return `${url}&utm_source=yougile&utm_medium=referral`
  }

  return `${url}?utm_source=yougile&utm_medium=referral`
}
